import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-view-layout',
  templateUrl: './view-layout.component.html',
  styleUrls: ['./view-layout.component.scss']
})
export class ViewLayoutComponent implements OnInit {

  isDashboard = false;
  constructor(
    private _router: Router,
    @Inject(DOCUMENT) private document: any,
  ) {
    this._router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          //console.log('this.router.url', this._router.url);
          if (this._router.url === '/') {
            this.document.body.classList.add('theme-dark');
            this.isDashboard = true;
          } else {
            this.document.body.classList.remove('theme-dark');
            this.isDashboard = false;
          }
        }
      }
    );
  }

  ngOnInit() {
  }

}
